<template>
    <jet-dialog-modal :show="true" @close="$emit('close')">
        <template #title>
            Cancel Subscription: Step 1
        </template>

        <template #content>
            <div class="">
                Are you sure you want to cancel your subscription?
            </div>
            <div class="mb-4 mt-4">
                You will lose:
                <ul class="list-disc ml-6">
                    <li><strong>Your current phone number</strong></li>
                    <li><strong>Your current A2P campaign registration status</strong> (<span class="italic">you’ll need to register, pay, and wait to get approved to send messages again if you come back later</span>)</li>
                </ul>
            </div>
            <div v-if="!$page.props.auth.user.organization.pause_at">
                Put your account on pause for $5/month to keep your account, phone number, and campaign registration active.
            </div>
        </template>

        <template #footer>

            <jet-button v-if="!$page.props.auth.user.organization.pause_at"
            secondary @click.native="$emit('pause'); $emit('close')" type="button">
                PAUSE ACCOUNT FOR $5/MONTH
            </jet-button>
            
            <jet-button text @click.native="$emit('continue-cancellation'); $emit('close')" type="button">
                Continue Cancellation
            </jet-button>

            
        </template>
    </jet-dialog-modal>

</template>


<script>
export default {
    name: 'CancelAccountConfirmModal',
    emits: ['close', 'pause', 'continue-cancellation'],
    components: {
    },
    computed: {
        
    }

}
</script>